enum UserCategoryResultType {
    String = "String",
    Number = "Number",
    Percentage = "Percentage",
    Answer = "Answer",
}

export {UserCategoryResultType};